import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState, useEffect } from 'react';
import UpdateDeposit from './updateDeposit';
import new_photo from 'assets/images/new_transparent.png';
import ImagesDialog from './ImagesDialog';
import { axiosInstance } from 'utils/axios';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import ApproveDepositModal from './ApproveDepositModal';
import RejectDepositModal from './RejectDepositModal';
import { useTranslation } from "react-i18next";

const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    { id: 'isNew', label: 'IsNew', minWidth: 120, type: 'indicator' },
    { id: 'clientName', label: 'Client Name', minWidth: 120 },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 120 },
    { id: 'amount', label: 'Amount', minWidth: 120 },
    { id: 'convertedAmount', label: 'Amount (USDT)', minWidth: 120 },
    { id: 'statusName', label: 'Status Name', minWidth: 120 },
    { id: 'thirdPartyName', label: 'Third Party Name', minWidth: 170 },
    { id: 'referrerCustomerString', label: 'Recommend By', minWidth: 170 },
    // { id: 'companyAgentClientName', label: '000 Name', minWidth: 170 },
    // { id: 'memberTypeName', label: 'Member Type', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 120, type: 'date' },
    { id: 'createdBy', label: 'Created By', minWidth: 120 },
    { id: 'userName', label: 'Username', minWidth: 120 },
    { id: 'transactionNumber', label: 'Transaction Number', minWidth: 170 },
    { id: 'phoneNumber', label: 'Phone Number', minWidth: 170 },
    { id: 'approvedDate', label: 'Approved Date', minWidth: 120, type: 'date' },
];

function StickyHeadTable({ deposit, fetchdepositRecord, customerLoginUserNames, status, thirdPartyIDs }) {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const token = useSelector(selectCurrentToken);
    const [selectedCustomerRow, setSelectedCustomerRow] = useState(null);
    const [approveDepositModalOpen, setApproveDepositModalOpen] = useState(false);
    const [rejectDepositModalOpen, setRejectDepositModalOpen] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    
    const openApproveDepositModal = (row) => {
        setSelectedCustomerRow(row);
        setApproveDepositModalOpen(true);
    };

    const openRejectDepositModal = (row) => {
        setSelectedCustomerRow(row);
        setRejectDepositModalOpen(true);
    };

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
                console.log('fetchIsUserAllowEdit', res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        Promise.all([fetchIsUserAllowEdit()]).catch((error) => {
            console.error('An error occurred:', error);
        });
    }, []);

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="id" style={{ minWidth: 170 }}>{t("withdrawal.date")}</TableCell>
                                <TableCell key="customerDetails" style={{ minWidth: 170 }}>{t("withdrawal.customer")}</TableCell>
                                <TableCell key="createdBy" style={{ minWidth: 170 }}>{t("withdrawal.admin")}</TableCell>
                                <TableCell key="bankDetails" style={{ minWidth: 170 }}>{t("withdrawal.bankDetails")}</TableCell>
                                <TableCell key="amount" style={{ minWidth: 170 }}>{t("withdrawal.actualAmount")}</TableCell>
                                <TableCell key="updatedBy" style={{ minWidth: 170 }}>{t("withdrawal.updatedBy")}</TableCell>
                                <TableCell key="action" style={{ minWidth: 170 }}>{t("withdrawal.setting")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {deposit.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key='id' style={{fontSize: "12px"}}>
                                            ID : {row.id} <br/>
                                            {t("withdrawal.createdAt")} {
                                            `${row.createdDate.split('T')[0]} ${new Date(
                                                '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                            ).toLocaleTimeString('en-US', {
                                                timeZone: 'UTC',
                                                hour12: true,
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                second: 'numeric'
                                            })}`}
                                        </TableCell>
                                        <TableCell key='customerDetails' style={{fontSize: "12px"}}>
                                            {t("withdrawal.code")} : {row.customerNumberCode} <br/>
                                            {row.loginUserName} ( {row.clientName} ) <br/>
                                            {t("withdrawal.phoneNumber")} : {row.phoneNumber} <br/>
                                        </TableCell>
                                        <TableCell key='createdBy' style={{fontSize: "12px"}}>
                                            {t("withdrawal.admin")}: {row.createdBy} <br/>
                                            {t("withdrawal.by")}: {row.referrerCustomerLoginUserName} {t("withdrawal.recommend")}
                                        </TableCell>
                                        <TableCell key='bankDetails' style={{fontSize: "12px"}}>
                                            {t("withdrawal.withdrawalAmount")} : {row.amount} <br/>
                                            {t("withdrawal.thirdPartyName")} : {row.thirdPartyName} <br/>
                                        </TableCell>
                                        <TableCell key="amount" style={{ fontSize: "12px", verticalAlign: 'middle' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box>
                                            {row.amount} <br />
                                            <span style={{ fontWeight: 'bolder', color: 
                                                row.statusID === 1 ? 'orange' : 
                                                row.statusID === 2 ? 'green' : 
                                                row.statusID === 3 ? 'red' : '' 
                                            }}>
                                                {row.statusID === 1
                                                ? t("withdrawal.pending")
                                                : row.statusID === 2
                                                ? t("withdrawal.approved")
                                                : row.statusID === 3
                                                ? t("withdrawal.rejected")
                                                : ''}
                                            </span>
                                            </Box>

                                            <ImagesDialog imageUrl={row.imageUrl} />
                                        </Box>
                                        </TableCell>
                                        <TableCell key='updatedBy' style={{fontSize: "12px"}}>
                                            {row.updatedBy}
                                        </TableCell>
                                        <TableCell key='action' style={{fontSize: "12px"}}>
                                            <Button
                                                onClick={() => openApproveDepositModal(row)}
                                                variant="contained"
                                                style={{
                                                    border: 'none',
                                                    backgroundColor: 'green',
                                                    width: 'fit-content',
                                                    height: 'fit-content',
                                                    color: 'white',
                                                    padding: '6px 8px',
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {t("withdrawal.approve")}
                                            </Button>
                                            <br/><br/>
                                            <Button
                                                onClick={() => openRejectDepositModal(row)}
                                                variant="contained"
                                                style={{
                                                    border: 'none',
                                                    backgroundColor: 'red',
                                                    width: 'fit-content',
                                                    height: 'fit-content',
                                                    color: 'white',
                                                    padding: '6px 8px',
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {t("withdrawal.reject")}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={deposit.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            {selectedCustomerRow && (
                <ApproveDepositModal
                    approveDepositModalOpen={approveDepositModalOpen}
                    setApproveDepositModalOpen={setApproveDepositModalOpen}
                    row={selectedCustomerRow}
                    fetchDeposit={fetchdepositRecord}
                />
            )}
        
            {selectedCustomerRow && (
                <RejectDepositModal
                    rejectDepositModalOpen={rejectDepositModalOpen}
                    setRejectDepositModalOpen={setRejectDepositModalOpen}
                    row={selectedCustomerRow}
                    fetchDeposit={fetchdepositRecord}
                />
            )}
        </>
    );
}

export default StickyHeadTable;
